import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'

const licenseFiltersWithAIUsageAllowed = [
  {
    value: LICENSE_TYPE.ALL,
    labelKey: 'all',
  },
  {
    value: LICENSE_TYPE.ROYALTY_FREE,
    labelKey: 'royalty_free',
  },
  {
    value: LICENSE_TYPE.EDITORIAL,
    labelKey: 'editorial',
  },
  {
    value: LICENSE_TYPE.CUSTOM,
    labelKey: 'custom',
  },
]

const licenseFiltersWithoutAIUsageAllowed = [
  {
    value: LICENSE_TYPE.ALL,
    labelKey: 'all',
  },
  {
    value: LICENSE_TYPE.ROYALTY_FREE_NO_AI,
    labelKey: 'royalty_free',
  },
  {
    value: LICENSE_TYPE.EDITORIAL_NO_AI,
    labelKey: 'editorial',
  },
  {
    value: LICENSE_TYPE.CUSTOM_NO_AI,
    labelKey: 'custom',
  },
]

const aiUsageFilters = [{
  value: 'ai_usage_allowed',
  labelKey: 'ai_usage_allowed',
}]

export const getLicenseFiltersConfig = (translate, aiUsageAllowed) => {
  const filters = aiUsageAllowed ? licenseFiltersWithAIUsageAllowed : licenseFiltersWithoutAIUsageAllowed

  return [{
    label: translate('search_page.filters.license.group_label'),
    filters: filters.map(filter => ({
      value: filter.value,
      label: translate(`search_page.filters.license.${filter.labelKey}`),
    })),
  }]
}

export const getAiUsageFiltersConfig = (translate) => [{
  label: translate('search_page.filters.license.ai_usage_group_label'),
  filters: aiUsageFilters.map(filter => ({
    value: filter.value,
    label: translate(`search_page.filters.license.${filter.labelKey}`),
  })),
}]
